import * as z from "zod/v4";
import { CustomerEventType } from "./customer-event/events/base";

export enum CustomerFilterComparisonOperator {
  GREATER_THAN_OR_EQUAL = ">=",
  GREATER_THAN = ">",
  LESS_THAN_OR_EQUAL = "<=",
  LESS_THAN = "<",
  EQUAL = "=",
  NOT_EQUAL = "!=",
}

export const customerFilterComparisonOperators = Object.values(
  CustomerFilterComparisonOperator,
);

export const customerFilterOperatorLabels: Record<
  CustomerFilterComparisonOperator,
  string
> = {
  [CustomerFilterComparisonOperator.GREATER_THAN_OR_EQUAL]:
    "greater than or equal to",
  [CustomerFilterComparisonOperator.GREATER_THAN]: "greater than",
  [CustomerFilterComparisonOperator.LESS_THAN_OR_EQUAL]:
    "less than or equal to",
  [CustomerFilterComparisonOperator.LESS_THAN]: "less than",
  [CustomerFilterComparisonOperator.EQUAL]: "equal to",
  [CustomerFilterComparisonOperator.NOT_EQUAL]: "not equal to",
};

const CustomerFilterComparisonOperatorSchema = z.enum([
  CustomerFilterComparisonOperator.GREATER_THAN_OR_EQUAL,
  CustomerFilterComparisonOperator.GREATER_THAN,
  CustomerFilterComparisonOperator.LESS_THAN_OR_EQUAL,
  CustomerFilterComparisonOperator.LESS_THAN,
  CustomerFilterComparisonOperator.EQUAL,
  CustomerFilterComparisonOperator.NOT_EQUAL,
]);

const CustomerFilterComparisonSchema_ = z.object({
  value: z.number(),
  operator: CustomerFilterComparisonOperatorSchema,
});
export const CustomerFilterComparisonSchema: z.ZodType<CustomerFilterComparison> =
  CustomerFilterComparisonSchema_;
export interface CustomerFilterComparison
  extends z.infer<typeof CustomerFilterComparisonSchema_> {}

const CustomerFilterSchema_ = z.object({
  orderCount: z.array(CustomerFilterComparisonSchema).optional(),
  lifetimeValue: z.array(CustomerFilterComparisonSchema).optional(),
  daysSinceLastPurchase: z.array(CustomerFilterComparisonSchema).optional(),
  eventCount: z
    .array(
      CustomerFilterComparisonSchema_.extend({
        eventType: z.enum(CustomerEventType),
      }),
    )
    .optional(),
  daysSinceEvent: z
    .array(
      CustomerFilterComparisonSchema_.extend({
        eventType: z.enum(CustomerEventType),
      }),
    )
    .optional(),
  returnsCount: z.array(CustomerFilterComparisonSchema).optional(),
  exchangesCount: z.array(CustomerFilterComparisonSchema).optional(),
});
export const CustomerFilterSchema: z.ZodType<CustomerFilter> =
  CustomerFilterSchema_;
export interface CustomerFilter extends z.infer<typeof CustomerFilterSchema_> {}
